import { Box, Modal, Typography } from "@mui/material";
import React from "react";
import Close from "../Icons/Close";
import cssClasses from "./AllotmentDetails.module.css";
import { makeStyles } from "@mui/styles";
import { useSelector } from "react-redux";
import Button from "../../Subcomponents/Button";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import Dot from "../Icons/Dot";
import ReactTimeAgo from "react-time-ago";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en.json";
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from "@mui/lab";
import DoneIcon from "@mui/icons-material/Done";
import CircleIcon from "@mui/icons-material/Circle";
import * as _ from "lodash";
import { numberWithCommas } from "../../Assets/Common/CommonFunctions";
const useStyles = makeStyles((theme) => ({
	tokenName: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "2rem",
		lineHeight: "3rem",
		color: "#000000",
	},
	wrapperIcons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		justifyContent: "space-around",
		marginBottom: "2rem",
		position: "relative",
	},
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "1.7rem",
		top: "1.7rem",
	},
	title: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.8rem",
		lineHeight: "2.8rem",
		color: "#101828",
		marginBottom: "0.8rem",
	},
	subTitle: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelCard: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	labelValue: {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: "500",
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#667085",
		marginBottom: "3.2rem",
	},
	wrapperButtons: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		justifyContent: "space-between",
		columnGap: "1.2rem",
	},
	backArrow: {
		verticalAlign: "middle",
	},
}));
const AllotmentDetails = ({ open, handleClose, returnRes, data }) => {
	const classes = useStyles();
	let loggedInUser = {};
	loggedInUser = useSelector((state) => state.Auth.user);
	TimeAgo.setDefaultLocale(en.locale);
	TimeAgo.addLocale(en);
	function closeModal() {
		handleClose();
	}
	const allotmentTransactions = _.orderBy(data.AllotmentTransactions, "created_at", "desc");
	const timeLine = allotmentTransactions.map((timelineItem, timelineIndex) => {
		return (
			<Timeline
				position="right"
				sx={[
					{
						padding: "0rem !important",
						margin: "0",
						[`& .MuiTimeline-root `]: {
							padding: "0rem !important",
						},
						"& . MuiTypography-root": {
							padding: "1.9rem 1.9rem !important",
						},
						[`& .MuiTimelineItem-root:before`]: {
							flex: "0rem !important",
							padding: "0rem !important",
							"-webkitFlex": "none !important",
							//  content:'none '
						},
					},
				]}
			>
				<TimelineItem key={`TimelineItem_${timelineIndex}`} color={timelineIndex === 0 ? `primary` : "grey"}>
					<TimelineSeparator>
						<TimelineDot sx={{ backgroundColor: "rgba(11, 165, 236, 0.3)" }}>
							{/* {timelineItem.isCompleted ? ( */}
							{timelineIndex === 0 ? <DoneIcon /> : <CircleIcon className={timelineIndex === 0 ? cssClasses.active : cssClasses.all} />}
						</TimelineDot>
						{timelineIndex !== data.AllotmentTransactions.length - 1 && (
							<TimelineConnector sx={{ backgroundColor: "rgba(11, 165, 236, 0.3)" }} />
						)}
					</TimelineSeparator>
					<TimelineContent>
						<Typography
							// fontFamily={"Roboto-Regular"}
							//  color={timelineIndex===0 ? `primary` : "#667085"}
							fontSize={"1.4rem"}
							style={{
								paddingTop: "1rem",
								textDecoration: timelineItem.isCompleted ? "line-through" : "none",
							}}
						>
							<div
								style={{
									fontSize: "1.4rem",
									fontFamily: "Inter-Medium",
									color: "#000000",
									lineHeight: "2rem",
									verticalAlign: "middle",
									marginRight: "0.5rem",
								}}
							>
								Transaction {timelineItem.status}
								{/* {timelineItem.status} */}
							</div>
							<div
								style={{
									fontSize: "1.2rem",
									fontFamily: "Inter-Medium",
									color: "#475467",
									lineHeight: "1.8rem",
									verticalAlign: "middle",
									marginRight: "0.5rem",
								}}
							>
								₹ {numberWithCommas(timelineItem.amount)}
							</div>
							<div
								style={{
									fontSize: "1.2rem",
									fontFamily: "Inter-Medium",
									color: "#475467",
									lineHeight: "1.8rem",
									verticalAlign: "middle",
									marginRight: "0.5rem",
								}}
							>
								{timelineItem.modeOfPayment}
							</div>
							<div
								style={{
									fontSize: "1.2rem",
									fontFamily: "Inter-Medium",
									color: "#475467",
									lineHeight: "1.8rem",
									verticalAlign: "middle",
									marginRight: "0.5rem",
								}}
							>
								{new Date(timelineItem.created_at).toDateString()},{" "}
								{new Date(timelineItem.created_at).toLocaleTimeString([], {
									hour: "2-digit",
									minute: "2-digit",
								})}
							</div>
						</Typography>
					</TimelineContent>
				</TimelineItem>
			</Timeline>
		);
	});
	return (
		<Modal
			open={open}
			onClose={(_, reason) => {
				if (reason !== "backdropClick") {
					closeModal();
				}
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
			sx={[
				{
					".MuiBackdrop-root": {
						background: "rgba(52, 64, 84, 0.7)",
					},
				},
			]}
			disableAutoFocus={true}
		>
			<Box className={cssClasses.modalWrapper}>
				<div className={cssClasses.wrapperHeader}>
					<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
						<Close width={"1.2rem"} height={"1.2rem"} />
					</span>
					<div>Allotment Details</div>
				</div>
				<div className={cssClasses.wrapperContent}>
					<div className={cssClasses.cardHeader}>
						<div className={cssClasses.tokenNumWrap}>
							{data.unitId && (
								<>
									<span>
										{data.unitId.wingId.displayName ? data.unitId.wingId.displayName : data.unitId.wingId.wingName} -{" "}
										{data.unitId.unitNo}{" "}
									</span>
									<span>|</span>
									<span>{data.unitId.projectId.projectName}</span>
								</>
							)}
							{data.inventoryMergedId && (
								<>
									{data.inventoryMergedId.unit1Id.wingId.wingId === data.inventoryMergedId.unit2Id.wingId.wingId && (
										<span>
											{data.inventoryMergedId.unit1Id.wingId.displayName
												? data.inventoryMergedId.unit1Id.wingId.displayName
												: data.inventoryMergedId.unit1Id.wingId.wingName}{" "}
											- {data.inventoryMergedId.unit1No} && {data.inventoryMergedId.unit2No}
										</span>
									)}
									{data.inventoryMergedId.unit1Id.wingId.wingId !== data.inventoryMergedId.unit2Id.wingId.wingId && (
										<span>
											{data.inventoryMergedId.unit1Id.wingId.displayName
												? data.inventoryMergedId.unit1Id.wingId.displayName
												: data.inventoryMergedId.unit1Id.wingId.wingName}{" "}
											- {data.unitId.unitNo}{" "}
										</span>
									)}
									<span>|</span>
									<span>{data.inventoryMergedId.projectId.projectName}</span>
								</>
							)}
						</div>
						{/* <div className={cssClasses.tokenStatus}>
							{data.status === "partial" && (
								<LeadStatusChip
									label={"Partial"}
									icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
									style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
								></LeadStatusChip>
							)}
							{data.status === "complete" && data.paidAmount >= data?.bookingAmt?.total + data.SDR && (
								<LeadStatusChip
									label={"Complete"}
									icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
									style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
								></LeadStatusChip>
							)}
							{data.status === "pending" && (
								<LeadStatusChip
									label={"Pending"}
									icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
									style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
								></LeadStatusChip>
							)}
							{(data.status === "Payment Complete" || data.status === "Agreement Done") &&
								(data.unitCost?.sdr) - data.paidAmt.sdr > 0 && (
									<LeadStatusChip
										label={"SDR Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
									></LeadStatusChip>
								)}
							{data.status === "expired" && (
								<LeadStatusChip
									label={"Expired"}
									icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
									style={{ color: "#0E7090", backgroundColor: "#ECFDFF" }}
								></LeadStatusChip>
							)}
						</div> */}
						<div className={cssClasses.tokenStatus}>
						{data?.status === "Payment Complete" || data?.status === "Agreement Done" ? (
							<>
								{data.status.includes("Cancellation Pending") && (
									<LeadStatusChip
										label={"Cancellation Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{(data.status === "Cancelled" ||
									data.status === "Change Requested" ||
									data.status === "Cancellation Requested") && (
									<LeadStatusChip
										label={data.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B42318",
											backgroundColor: "#FEF3F2",
										}}
									></LeadStatusChip>
								)}
								{/* ? if 5,00,000 amount is paid; check for SDR amount */}
								{data?.paidAmt?.sdr >=
																	(data?.unitCost?.sdr) ? (
									<LeadStatusChip
										label={"SDR Complete"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#027A48", backgroundColor: "#ECFDF3" }}
									></LeadStatusChip>
								) : (
									<LeadStatusChip
										label={"SDR Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{ color: "#B54708", backgroundColor: "#FFFAEB" }}
									></LeadStatusChip>
								)}
								{!data.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{data.kycFormFilled && (
									<LeadStatusChip
										label={"KYC Done"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}

								{data.preselectConfirmation === "confirmation pending" && (
									<LeadStatusChip
										label={"Confirmation Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
							</>
						) : (
							<>
								{data?.status.includes("Cancellation Pending") && (
									<LeadStatusChip
										label={"Cancellation Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{(data?.status === "cancelled" ||
									data?.status === "Cancelled" ||
									data?.status === "Cancellation Rejected" ||
									data?.status === "Change Requested" ||
									data?.status === "Cancellation Requested") && (
									<LeadStatusChip
										label={data?.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B42318",
											backgroundColor: "#FEF3F2",
										}}
									></LeadStatusChip>
								)}
								{data?.status === "Partial Payment Done" && (
									<LeadStatusChip
										label={data.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B54708",
											backgroundColor: "#FFFAEB",
										}}
									></LeadStatusChip>
								)}
								{data?.status === "Payment Pending" && (
									<LeadStatusChip
										label={"Payment Pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#B42318",
											backgroundColor: "#FEF3F2",
										}}
									></LeadStatusChip>
								)}
								{data?.status === "expired" && (
									<LeadStatusChip
										label={"Expired"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{data?.status === "On Hold" && (
									<LeadStatusChip
										label={data.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#3538CD",
											backgroundColor: "#EEF4FF",
										}}
									></LeadStatusChip>
								)}
								{(data?.status === "Released" ||
									data?.status === "Refund Processed" ||
									data?.status === "Refund Initiated") && (
									<LeadStatusChip
										label={data?.status}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "rgb(180, 35, 24)",
											backgroundColor: "rgb(254, 243, 242)",
										}}
									></LeadStatusChip>
								)}
								{data?.status === "Partial Payment Done" && !data?.kycFormFilled && (
									<LeadStatusChip
										label={"Kyc pending"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
								{data?.kycFormFilled && (
									<LeadStatusChip
										label={"KYC Done"}
										icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
										style={{
											color: "#0E7090",
											backgroundColor: "#ECFDFF",
										}}
									></LeadStatusChip>
								)}
							</>
						)}
					</div>
						<div className={cssClasses.tokenLastUpdate}>
							<ReactTimeAgo style={{ fontSize: "1.2rem" }} date={data?.last_updated_at ?? data?.created_at} locale="en-US" />
						</div>
					</div>
					<div className={cssClasses.cardDetails}>
						<div className={cssClasses.allotmentDetails}>
							<div className={cssClasses.tokenDetails}>
								{data.paymentId && (
									<div className={cssClasses.tokenData}>
										<span>{data.paymentId?.eventTokenId?.eventId?.title}</span>
									</div>
								)}
								<div className={cssClasses.tokenData}>
									{data.unitId && (
										<>
											<span>{data.unitId.inventoryTypeId.type}</span>
											<span>|</span>
											<span>{data.unitId.floorNo}</span>
											{/* <span>Floor {data.unitId.floorNo}</span> */}
										</>
									)}
									{data.inventoryMergedId && (
										<>
											{data.inventoryMergedId.unit1Id.inventoryTypeId.type ===
												data.inventoryMergedId.unit2Id.inventoryTypeId.type && (
												<span>{data.inventoryMergedId.unit1Id.inventoryTypeId.type}</span>
											)}
											{data.inventoryMergedId.unit1Id.inventoryTypeId.type !==
												data.inventoryMergedId.unit2Id.inventoryTypeId.type && (
												<span>
													{data.inventoryMergedId.unit1Id.inventoryTypeId.type} -{" "}
													{data.inventoryMergedId.unit2Id.inventoryTypeId.type}
												</span>
											)}
											<span>|</span>
											{data.inventoryMergedId.unit1Id.floorNo === data.inventoryMergedId.unit2Id.floorNo && (
												<span>{data.inventoryMergedId.unit1Id.floorNo}</span>
											)}
											{data.inventoryMergedId.unit1Id.floorNo !== data.inventoryMergedId.unit2Id.floorNo && (
												<span>
													{data.inventoryMergedId.unit1Id.floorNo} - {data.inventoryMergedId.unit2Id.floorNo}
												</span>
											)}
										</>
									)}
								</div>
								<div className={cssClasses.tokenData}>
									<span>Alloted on : </span>
									<span>
										{new Date(data.created_at).toDateString()},{" "}
										{new Date(data.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
									</span>
								</div>
								<div className={cssClasses.tokenData}>
									<div className={cssClasses.bookingPriceBreakDown}>
										<div className={cssClasses.price}>
											<span>OCR : </span>
											<span>₹ {numberWithCommas(data.bookingAmt?.ocr)}</span>
										</div>
										<div className={cssClasses.price}>
											<span>SDR : </span>
											<span>₹ {numberWithCommas(data.bookingAmt?.sdr)}</span>
										</div>
										<div className={cssClasses.price}>
											<span>GST : </span>
											<span>₹ {numberWithCommas(data.bookingAmt?.gst)}</span>
										</div>
										<div className={cssClasses.price}>
											<span>Booking Amount: </span>
											<span>₹ {numberWithCommas(data?.bookingAmt?.total)}</span>
										</div>
									</div>
								</div>
								<div className={cssClasses.tokenData}>
									<div className={cssClasses.bookingPriceBreakDown}>
										<div className={cssClasses.price}>
											<span>Agreement Value : </span>
											<span>₹ {numberWithCommas(data.unitCost?.bsp)}</span>
										</div>
										<div className={cssClasses.price}>
											<span>SDR : </span>
											<span>₹ {numberWithCommas(data.unitCost?.sdr)}</span>
										</div>
										<div className={cssClasses.price}>
											<span>GST : </span>
											<span>₹ {numberWithCommas(data.unitCost?.gst)}</span>
										</div>
									</div>
								</div>
							</div>

							<div className={cssClasses.cardFooter}>
								{data.showUnitPrice && (
									<div className={cssClasses.priceBreakDown}>
										<div className={cssClasses.price}>
											<span>Total SDR : </span>
											<span>₹ {numberWithCommas(data.SDR)}</span>
										</div>
										<div className={cssClasses.price}>
											<span>SDR Paid : </span>
											<span>₹ {numberWithCommas(data.paidAmount - data?.bookingAmt?.total)}</span>
										</div>
										<div className={cssClasses.price}>
											<span>GST : </span>
											<span>₹ {numberWithCommas(data.GST)}</span>
										</div>
									</div>
								)}
								<div className={cssClasses.totalAmt}>
									<div>
										<span>Booking Amount : </span>
											<span>₹ {numberWithCommas(data?.bookingAmt?.total)}</span>
									</div>
								</div>
								<div className={cssClasses.paidAmt}>
									<span>Paid Amount : </span>
									<span>₹ {numberWithCommas(data.paidAmount)}</span>
								</div>
								<div className={cssClasses.totalAmt}>
									<span>Total Cost of Unit : </span>
									<span> ₹ {numberWithCommas(data?.unitCost?.total)}</span>
								</div>
							</div>
						</div>

						<div className={cssClasses.transactionDetails}>{timeLine}</div>
					</div>
				</div>
				<div className={cssClasses.wrapperFooter}>
					<Button
						style={{
							color: "#ffffff",
							backgroundColor: "#155EEF",
							fontSize: "1.6rem",
							lineHeight: "2.4rem",
							width: "auto",
						}}
						btnName={"OK"}
						clicked={() => {
							closeModal();
						}}
						//   disable={disabeNext}
					/>
				</div>
			</Box>
		</Modal>
	);
};

export default AllotmentDetails;
